import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          {/* Brand Column */}
          <div className="footer-brand">
            <div className="footer-logo">
              <img src="/logo.jpeg" alt="Kitto Di Kulfi" />
              <span>Kitto Di Kulfi</span>
            </div>
            <p>
              Serving happiness one scoop at a time. Experience the authentic taste 
              of traditional kulfi and artisan ice creams made with love and the 
              finest ingredients.
            </p>
            <div className="footer-social">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                📘
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                📸
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                🐦
              </a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="YouTube">
                📺
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-column">
            <h4>Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/menu">Menu</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          {/* Menu Categories */}
          <div className="footer-column">
            <h4>Our Menu</h4>
            <ul className="footer-links">
              <li><Link to="/menu">Traditional Kulfi</Link></li>
              <li><Link to="/menu">Ice Cream</Link></li>
              <li><Link to="/menu">Shakes & Smoothies</Link></li>
              <li><Link to="/menu">Sundaes & Specials</Link></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-column">
            <h4>Contact Us</h4>
            <ul className="footer-links">
              <li>📍 Shop No. 12, Main Market</li>
              <li style={{ paddingLeft: '25px' }}>Delhi - 110001</li>
              <li>📞 +91 98765 43210</li>
              <li>✉️ hello@kittodikulfi.com</li>
              <li>⏰ 11 AM - 11 PM (All Days)</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="footer-bottom">
          <p>
            © {currentYear} <span>Kitto Di Kulfi</span>. All Rights Reserved. 
            Made with ❤️ for ice cream lovers.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
